import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import * as Papa from 'papaparse';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { EnvironmentAdapter } from 'src/app/adapters/environment/environment.adapter';
import { Translations } from 'src/app/adapters/translation/model/translations.model';

export class TranslationLoader implements TranslateLoader {
    constructor(
      private httpClient: HttpClient,
      private environmentAdapter: EnvironmentAdapter
    ) {}

    getTranslation(lang: string): Observable<any> {
      const translationMapObs = this.environmentAdapter.getEnvironment()
        .pipe(
          switchMap((environment) => {
            const translationsFilepath = environment.browserAppConfig.translationsFilepath;
            return this.httpClient.get(translationsFilepath, { responseType: 'text' });
          }),
          map((data: string) => this.mapCSVToTranslations(data, lang))
        );

      return translationMapObs;
    }

    private mapCSVToTranslations(csvData: string, lang: string): Translations {
      const data = Papa.parse<string[]>(csvData).data;
      const header = data[0];
      const langIndex = header.indexOf(lang);

      if (langIndex === -1) return {};

      const translations = data
        .slice(1)
        .reduce((acc: Translations, columns: string[]) => {
          const key = columns[0];
          const value = columns[langIndex] || key;

          acc[key] = value;
          return acc;
        }, {});

      return translations;
    }
}
